import { useAtom } from "jotai";
import { useMemo } from "react";
import { JWTAtom } from "../atoms";
import { Jwt } from "../utils/interfaces";

const useIsAuth = () => {
  const [atom] = useAtom(JWTAtom);
  const jwt: Jwt | boolean = useMemo(() => JSON.parse(atom), [atom]);
  const isAuth = useMemo(() => (jwt === false ? false : true), [jwt]);
  return isAuth;
};

export default useIsAuth;
